import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Admin from './Admin';
import * as downtimeActions from '../../actions/error-actions';

import './Admin.css';

const mapStateToProps = state => ({
  filters: state.filters,
  user: state.user,
  downtime: state.downtime
});

const mapDispatchToProps = dispatch => ({
  downtimeActions: bindActionCreators(downtimeActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
